export const DefaultSelectProps = {
  size: 'xl',
  radius: 6
};
